import { ArtistFestivals, ArtistShows } from '@features';
import { Stack } from '@mantine/core';

export const ArtistDetailsShowsPage: React.FC = () => {
  return (
    <Stack py="md">
      <ArtistShows />
      <ArtistFestivals />
    </Stack>
  );
};
